import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, Search, ShoppingBag } from "lucide-react";
import { Logo } from "@/components/Logo";
import { MobileMenu } from "@/components/MobileMenu";
import { CategoryStrip } from "@/components/CategoryStrip";
import { useCart } from "@/context/CartContext";

const LINKS = [
  ["/catalogo", "Catalogo"],
  ["/catalogo?offerte=1", "Offerte"],
  ["/categoria/offerte-iphone-samsung-cloud-free-octacore", "Cloud Free"],
  ["/assistenza", "Assistenza"],
  ["/contatti", "Contatti"],
];

export const Header = () => {
  const { count, setOpen } = useCart();
  const [q, setQ] = useState("");
  const [menu, setMenu] = useState(false);
  const nav = useNavigate();
  const submit = (e) => {
    e.preventDefault();
    nav(q.trim() ? `/catalogo?q=${encodeURIComponent(q.trim())}` : "/catalogo");
  };

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-white/90 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-7xl items-center gap-3 px-4 sm:px-6">
        <button className="rounded-lg p-2 text-slate-700 hover:bg-slate-100 lg:hidden" onClick={() => setMenu(true)} aria-label="Apri menu" data-testid="mobile-menu-btn">
          <Menu className="h-5 w-5" />
        </button>
        <Link to="/" data-testid="header-logo-link"><Logo /></Link>
        <nav className="ml-8 hidden items-center gap-7 text-sm lg:flex">
          {LINKS.map(([to, label]) => (
            <NavLink key={to} to={to} end data-testid={`nav-${label.toLowerCase().replace(" ", "-")}`} className="font-medium text-slate-600 transition-colors hover:text-[#0066FF]">
              {label}
            </NavLink>
          ))}
        </nav>
        <form onSubmit={submit} className="relative ml-auto hidden w-72 md:block">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca iPhone, Samsung, MacBook…" data-testid="nav-search-input"
            className="h-10 w-full rounded-full border border-slate-200 bg-slate-100/70 pl-9 pr-4 text-sm text-slate-900 placeholder:text-slate-400 outline-none transition-colors focus:border-[#0066FF] focus:bg-white" />
        </form>
        <Link to="/catalogo" className="ml-auto rounded-lg p-2 text-slate-700 hover:bg-slate-100 md:hidden" aria-label="Cerca" data-testid="mobile-search-link">
          <Search className="h-5 w-5" />
        </Link>
        <button onClick={() => setOpen(true)} aria-label="Apri carrello" data-testid="cart-drawer-toggle"
          className="relative rounded-full border border-slate-200 p-2.5 text-slate-900 transition-colors hover:border-[#0066FF] hover:text-[#0066FF]">
          <ShoppingBag className="h-5 w-5" />
          {count > 0 && (
            <span data-testid="cart-count-badge" className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[#0066FF] px-1 font-mono text-[10px] font-medium text-white">
              {count}
            </span>
          )}
        </button>
      </div>
      <CategoryStrip />
      <MobileMenu open={menu} onOpenChange={setMenu} links={LINKS} />
    </header>
  );
};
